const COMPONENT_NAME = "AdSet";
const MODULE_SETTING_DEVELOPER_KEY = "ad_set";
const LINK_LABEL_KEY = "linklabel";
export {
  COMPONENT_NAME,
  LINK_LABEL_KEY,
  MODULE_SETTING_DEVELOPER_KEY
};
